import { CampaignStepId } from 'modules/campaigns/campaign-steps/types/campaign-step-interface'
import { CampaignId } from 'modules/campaigns/types/campaign-interface'

export const getCampaignStepsEditorNextjsUrl = ({
  campaignId,
  campaignStepId,
}: {
  campaignId: CampaignId
  campaignStepId: CampaignStepId
}) => `/campaigns/${campaignId}/campaign-step/${campaignStepId}/edit`
